import { categoryLabel, complaintTypeLabel, formatStamp } from "../../lib/complaints";
import { Tag, LBL } from "../msd/ui";

// A complaint the AI detected but the customer hasn't confirmed yet (or
// declined) — there is no complaints row for it, so it can't use
// ComplaintCard's stage tracker/actions. Read-only: nothing staff can do but
// wait for the customer's WhatsApp reply.
export default function PendingCandidateCard({ candidate }) {
  return (
    <div
      className="flex flex-col gap-[10px] rounded-[14px] bg-msd-surface p-4 shadow-msd-e1"
      data-testid={`complaint-candidate-${candidate.id}`}
    >
      <div className="flex flex-wrap items-center gap-2">
        <Tag tone="grey">{categoryLabel(candidate.category)}</Tag>
        <Tag tone="grey">{complaintTypeLabel(candidate.complaint_type)}</Tag>
        <Tag tone="orange" className="ml-auto">
          Awaiting confirmation
        </Tag>
      </div>
      <div className="text-[16px]">{candidate.summary || "Possible complaint detected."}</div>
      <div className={LBL}>
        Detected {formatStamp(candidate.asked_at)} — we asked the customer 1:1 whether to register this.
      </div>
    </div>
  );
}
